module.exports = __webpack_public_path__ + "img/kFtr.bc049cb4.svg";